import moment from 'moment';
let startDt = moment().startOf('month').format('YYYY-MM-DD');
let endDt = moment().endOf('month').format('YYYY-MM-DD');

export default {
	searchParams: SEARCH_PARAMS(),
	pagingInfo: PAGING_INFO(),
	eo4mInfo: EO4M_INFO(),
	pprInfoKd: PPR_INFO_KD(),
	pprInfoLp: PPR_INFO_LP(),
	partCkuInfo: PART_CKU_INFO(),
	fwdInfo: FWD_INFO(),
	partClCdList: [] //유형
};

function SEARCH_PARAMS() {
	return {
		strDt: startDt,
		endDt: endDt,
		partClCd: ''
	};
}

function EO4M_INFO() {
	return {
		noEo4mApprCnt: '', //작성중
		reg10Cnt: '', //반려
		reg20Cnt: '', //작성
		reg30Cnt: '', //검토
		reg40Cnt: '', //승인
		reg50Cnt: '', //완료
		rsltOkCnt: '', // 승인결과 합격
		rsltNgCnt: '', // 승인결과 불합격
		isir10Cnt: '', // 승인필요
		isir20Cnt: '' // 승인불필요
	};
}

function PART_CKU_INFO() {
	return {
		ckuReg10Cnt: '', //작성중
		ckuReg10CkuCnt: '', //검사수량
		ckuReg10BadCnt: '', //불량수량
		ckuReg20Cnt: '', //검사완료
		ckuReg20CkuCnt: '', //검사수량
		ckuReg20BadCnt: '', //불량수량
		ckuReg30Cnt: '', //반려
		ckuReg30CkuCnt: '', //검사수량
		ckuReg30BadCnt: '', //불량수량
		ckuReg40Cnt: '', //검토
		ckuReg40CkuCnt: '', //검사수량
		ckuReg40BadCnt: '', //불량수량
		ckuReg50Cnt: '', //승인
		ckuReg50CkuCnt: '', //검사수량
		ckuReg50BadCnt: '', //불량수량
		crePprNoCnt: '', //불량보고 작성 수량
		noCrePprNoCnt: '' //불량보고 미작성 수량
	};
}

function PPR_INFO_KD() {
	return {
		kdReg00Cnt: '', //입력중
		kdReg10Cnt: '', //반려
		kdReg20Cnt: '', //작성
		kdReg30Cnt: '', //검토
		kdReg40Cnt: '', //승인
		kdMdvDdCnt: '' //대책완료
	};
}

function PPR_INFO_LP() {
	return {
		lpReg00Cnt: '', //작성중
		lpReg10Cnt: '', //반려
		lpReg20Cnt: '', //작성
		lpReg30Cnt: '', //검토
		lpReg40Cnt: '', //회신
		lpReg50Cnt: '', //승인
		lpMdvDdCnt: '' //대책완료
	};
}

function FWD_INFO() {
	return {
		fwdTotCnt: '' /* 제품 ID수 */,
		fwdOkCnt: '' /* 종합판정결과 OKCNT */,
		fwdNgCnt: '' /* 종합판정결과 NGCNT */,
		ngPowQltyCdCnt: '' /* 공정품질코드 */,
		ngApenCkuCdCnt: '' /* 외관검사코드 */,
		ngClfcStCdCnt: '' /* 체결상태코드 */,
		ngCdcnStCdCnt: '' /* 배선상태코드(배선배관) */,
		ngPartBloCdCnt: '' /* 부품누락체크코드(lot누락) */,
		ngPartSrgCdCnt: '' /* 부품NG 체크코드(결품) */,
		ngOputStCdCnt: '' /* 출력상태코드 */
	};
}

function PAGING_INFO() {
	return {
		currentPage: 1,
		endPage: 1,
		pageUnit: 30,
		startPage: 1,
		totalSize: 1
	};
}
export { SEARCH_PARAMS, PAGING_INFO, EO4M_INFO, PART_CKU_INFO, PPR_INFO_KD, PPR_INFO_LP, FWD_INFO };
